import {
  REQUEST,
  FAILURE,
  SUCCESS,
  FULFILL,
} from "common/rdx/reducer-status.constants";

export const GET_USER_LIST = "GET_USER_LIST";
export const POST_NEW_USER = "POST_NEW_USER";
export const ADD_USER_ROLES = "ADD_USER_ROLES";
export const DELETE_USER = "DELETE_USER";
export const EDIT_USER = "EDIT_USER";

export const USER_ADDED_MSG = "user added successfully";
export const ROLES_ADDED_MSG = "roles added successfully";

// GET USER LIST ACTIONS
export const getUserListAction = (actionCallback) => async (dispatch) => {
  dispatch({
    type: GET_USER_LIST,
    status: REQUEST,
  });

  let userList;
  try {
    userList = await actionCallback();
  } catch (error) {
    dispatch({
      type: GET_USER_LIST,
      status: FAILURE,
      message: error,
    });
    return;
  }

  dispatch({
    type: GET_USER_LIST,
    status: SUCCESS,
    payload: { userList },
    message: null,
  });
};

export const cancelGetUserListAction = (cancelCallback) => (dispatch) => {
  cancelCallback();
  dispatch({
    type: GET_USER_LIST,
    status: FULFILL,
  });
};

// POST USER ACTIONS
export const postNewUserAction =
  (postUserCallback, userFormValues) => async (dispatch) => {
    dispatch({
      type: POST_NEW_USER,
      status: REQUEST,
    });

    let userData;
    try {
      userData = await postUserCallback(userFormValues);
    } catch (error) {
      dispatch({
        type: POST_NEW_USER,
        status: FAILURE,
        message: error,
      });
      return null;
    }

    dispatch({
      type: POST_NEW_USER,
      status: SUCCESS,
      message: USER_ADDED_MSG,
      payload: { userData },
    });
    return userData.id;
  };

export const cancelPostNewUserAction = (cancelCallback) => (dispatch) => {
  cancelCallback();
  dispatch({
    type: POST_NEW_USER,
    status: FULFILL,
  });
};

// ADD USER ROLES ACTIONS
export const addUserRolesAction =
  (actionCallback, userRoles, userId) => async (dispatch) => {
    if (userId) {
      dispatch({
        type: ADD_USER_ROLES,
        status: REQUEST,
      });

      try {
        await actionCallback(userRoles, userId);
      } catch (error) {
        dispatch({
          type: ADD_USER_ROLES,
          status: FAILURE,
          message: error,
        });
        return;
      }

      dispatch({
        type: ADD_USER_ROLES,
        status: SUCCESS,
        message: ROLES_ADDED_MSG,
      });
    }
  };

export const cancelAddUserRolesAction = (cancelCallback) => (dispatch) => {
  cancelCallback();
  dispatch({
    type: ADD_USER_ROLES,
    status: FULFILL,
  });
};

// DELETE USERS ACTIONS
export const deleteUserAction =
  (deleteUserCallback, usersToDelete) => async (dispatch) => {
    dispatch({
      type: DELETE_USER,
      status: REQUEST,
    });

    try {
      await deleteUserCallback(usersToDelete);
    } catch (error) {
      dispatch({
        type: DELETE_USER,
        status: FAILURE,
        message: error,
      });
      return;
    }

    dispatch({
      type: DELETE_USER,
      status: SUCCESS,
    });
  };

export const cancelDeleteUserAction = (cancelCallback) => (dispatch) => {
  cancelCallback();
  dispatch({
    type: DELETE_USER,
    status: FULFILL,
  });
};

// EDIT USER ACTIONS
export const editUserAction =
  (editUserCallback, usersToEdit) => async (dispatch) => {
    dispatch({
      type: EDIT_USER,
      status: REQUEST,
    });

    let userEditedId;
    try {
      userEditedId = await editUserCallback(usersToEdit);
    } catch (error) {
      dispatch({
        type: EDIT_USER,
        status: FAILURE,
        message: error,
      });
      return null;
    }

    dispatch({
      type: EDIT_USER,
      status: SUCCESS,
    });
    return userEditedId;
  };

export const cancelEditUserAction = (cancelCallback) => (dispatch) => {
  cancelCallback();
  dispatch({
    type: EDIT_USER,
    status: FULFILL,
  });
};
